import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, useQueryClient, UseMutationResult } from 'react-query';
import { ErrorMessage, WorkoutTemplate } from 'types';
import { client } from 'utils/api-client';

export default function useDuplicateWorkoutTemplate(): UseMutationResult<
  AxiosResponse<WorkoutTemplate>,
  AxiosError<ErrorMessage>,
  string
> {
  const queryClient = useQueryClient();

  const duplicateWorkoutTemplate = (workoutTemplateId: string): Promise<AxiosResponse<WorkoutTemplate>> => {
    return client.post(`workout-templates/${workoutTemplateId}/duplicate/`);
  };

  return useMutation(duplicateWorkoutTemplate, {
    onSuccess: () => {
      queryClient.invalidateQueries('workoutTemplates');
    },
  });
}
